export default __webpack_public_path__ + "static/media/wa.b0f85ac9.mp3";